import React from "react";
import { useTranslation } from "react-i18next";
import { BannerBase } from "../BannerBase";
import { ProgressBar } from "components/widgets/progress-bar/ProgressBar";
import { useLivestreamMinutes } from "hooks/useLivestreamMinutes";
import { displayResetDate } from "helpers/time";
import styles from "./index.module.scss";

const WARNING_RATIO = 0.8;

export const StreamingTimeBanner: React.FC = () => {
    const { t, i18n } = useTranslation();
    const {
        hasLimit,
        usedSeconds,
        maxSeconds,
        usedRatio,
        periodEnd,
        isOutOfMinutes
    } = useLivestreamMinutes();

    if (!hasLimit) return null;

    const maxMinutes = Math.floor(maxSeconds / 60);
    const usedMinutes = isOutOfMinutes
        ? maxMinutes
        : Math.floor(usedSeconds / 60);

    const resetDate = displayResetDate(periodEnd, i18n.language);

    const header = isOutOfMinutes
        ? t("home:streaming-time-header-out")
        : usedRatio >= WARNING_RATIO
          ? t("home:streaming-time-header-warning")
          : t("home:streaming-time-header");

    const variant = isOutOfMinutes
        ? "thin-video-storage-max"
        : usedRatio >= WARNING_RATIO
          ? "thin-video-storage-medium"
          : "thin-video-storage";

    return (
        <BannerBase
            header={header}
            subheader={
                resetDate
                    ? t("home:streaming-time-reset", { date: resetDate })
                    : undefined
            }
        >
            <div className={styles["progress"]}>
                <ProgressBar
                    currentValue={usedMinutes}
                    maxValue={maxMinutes}
                    variant={variant}
                    showRemaining
                    plainCount
                    unit={t("home:streaming-time-unit")}
                />
            </div>
        </BannerBase>
    );
};
